import { render, staticRenderFns } from "./RequestTabs.vue?vue&type=template&id=71a982c0"
import script from "./RequestTabs.vue?vue&type=script&lang=js"
export * from "./RequestTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports